<script>
import BaseButton from '@/components/lavender/v2/BaseButton.vue'

export default {
  name: 'AdsPostpaidPaymentSuccess',
  components: {
    BaseButton,
  },
}
</script>

<template>
  <div class="ads-postpaid-payment-success">
    <div class="icon-container success-icon">
      <svg-icon icon-class="ads-success" />
    </div>
    <h1>{{ $t('ads_payment_successful') }}</h1>
    <p>{{ $t('ads_payment_success_msg') }}</p>
    <BaseButton
      type="primary"
      class="mt-8 w-full"
      track-id="ads_postpaid_success_close"
      @click="$router.replace('/ads/postpaid/invoice')"
    >
      {{ $t('ads_dialog_close') }}
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
.ads-postpaid-payment-success {
  display: contents;

  h1 {
    font-size: 28px;
  }

  .icon-container {
    svg {
      width: 72px;
      height: 72px;
    }
  }

  p {
    margin-top: 8px;
    color: var(--content-mid);
  }
}
</style>
